import { render } from "./CompareToDonorDataComponent.vue?vue&type=template&id=1b5d57cc&scoped=true"
import script from "./CompareToDonorDataComponent.vue?vue&type=script&lang=js"
export * from "./CompareToDonorDataComponent.vue?vue&type=script&lang=js"

import "./CompareToDonorDataComponent.vue?vue&type=style&index=0&id=1b5d57cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5d57cc"]])

export default __exports__